import { render } from "./MyDialog.vue?vue&type=template&id=76dc5b4a&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"

import "./MyDialog.vue?vue&type=style&index=0&id=76dc5b4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76dc5b4a"

export default script